import Tool, { type IToolActionInput, type IToolEnabledInput } from './Tool';
import { isShape } from '../objects/guards';
import Shortcut from '../utils/Shortcut';

class ToolLinkObjectToEdit extends Tool {
  static toolName = 'Edit link';

  static shortcut = new Shortcut('Cmd+Option+K');

  static async action({ controller, selection }: IToolActionInput) {
    if (selection) {
      controller.actionShowUrlInputModal(selection);
    }
  }

  // Only enabled when a single item is selected
  static enabled({ selection }: IToolEnabledInput) {
    return !!(selection && isShape(selection) && selection.linkToUrl);
  }
}

export default ToolLinkObjectToEdit;
